import { SignOutReason } from '@suntex.fim/auth';
import { useAuth } from '@suntex.fim/auth/react';
import { Modal } from '@suntex.fim/ui';

export function SessionExpiredModal() {
  const { signOutReason, signOut } = useAuth();

  const isExpired = signOutReason === SignOutReason.Expired;

  function handleOk() {
    void signOut().finally(() => {
      window.location.replace('/');
    });
  }

  return (
    <Modal
      closable={false}
      okText="OK"
      onOk={handleOk}
      open={isExpired}
      title="Session Expired"
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      Your session has expired. Please sign in again to continue.
    </Modal>
  );
}
